import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

const aiDevelopmentFaqs = [
  { question: 'How do we identify the right AI opportunity?', answer: 'We start with your business goals, workflow friction, available data and measurable success criteria. That assessment helps us prioritize use cases where AI can create meaningful value instead of adding another disconnected tool.' },
  { question: 'Can you connect AI to our existing systems?', answer: 'Yes. We integrate AI capabilities with the platforms, applications and data environments your teams already use, including enterprise software, customer channels and operational workflows.' },
  { question: 'How do you move an AI idea into production?', answer: 'We validate the concept with representative data and users, establish the right architecture, test model behavior, add monitoring and then scale the solution through a controlled production rollout.' },
  { question: 'How do you approach AI security and governance?', answer: 'Security, access control, evaluation, traceability and human oversight are considered throughout delivery. We shape governance around your risk profile, industry expectations and the way the system will actually be operated.' },
  { question: 'Can PTKCS support the solution after launch?', answer: 'Yes. We can continue with monitoring, model improvement, platform support, optimization and capability transfer so your AI systems stay useful as your data, users and business priorities evolve.' },
];

export default function AIDevelopmentFaqs() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <section className="border-t px-5 py-14 sm:px-6 sm:py-16 lg:px-10 lg:py-12" style={{ background: '#FFFFFF', borderColor: '#E5E8ED' }}>
      <div className="mx-auto max-w-5xl">
        <div className="max-w-7xl text-center">
          <h2 className="text-[32px] font-semibold leading-[48px]" style={{ color: '#183762' }}>
            Questions about building AI with PT KCS?
          </h2>
          <p className="mx-auto mt-5 max-w-4xl text-center text-base font-normal leading-[27px] sm:mt-6" style={{ color: '#212121' }}>
            A few practical answers about our approach, delivery process and long-term support for enterprise AI.
          </p>
        </div>

        <div className="mt-8 border-t sm:mt-12" style={{ borderColor: '#DCE3EC' }}>
          {aiDevelopmentFaqs.map((faq, index) => {
            const isOpen = openFaq === index;
            return (
              <div key={faq.question} className="border-b" style={{ borderColor: '#DCE3EC' }}>
                <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left sm:gap-6 sm:py-6">
                  <span className="text-base font-semibold leading-6 sm:text-lg" style={{ color: '#183762' }}>{faq.question}</span>
                  <ChevronDown size={21} className={`shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} style={{ color: '#0b3b78' }} />
                </button>
                {isOpen && <p className="max-w-5xl pb-5 pr-3 text-base font-normal leading-[27px] sm:pb-6 sm:pr-10" style={{ color: '#212121', wordBreak: 'normal', overflowWrap: 'normal', hyphens: 'none', whiteSpace: 'normal' }}>{faq.answer}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
